<template>
   <span class="statistics-global-filter__filter">
        <select name="group_by_consultant_level" id="group_by_consultant_level" class="form-control select2-rendered" data-allow-clear="true" ref="filter" data-placeholder="Select...">
            <option value=""></option>
            <option :value="option.value" v-for="(option, index) in config.options" v-if="index > 0" :data-_lft="option._lft">{{ option.label }}</option>
        </select>
    </span>
</template>

<script>
    export default {
        props: ['config'],
        created() {
            this.$nextTick(() => {
                $(this.$refs.filter).on('change', function () {
                    Event.$emit('groupByConsultantLevelFilterChanged', $(this).val());
                });
            });

            Event.$emit('groupByConsultantLevelFilterChanged', this.config.options[0].value);

            Event.$on('consultantLevelFilterChanged',  (consultantLevel) => {

                let select = $(this.$refs.filter);
                select.select2('destroy');
                let options = select.find('option');

                $(options).each(function () {
                    if($(this).data('_lft') <= consultantLevel._lft) {
                        $(this).prop("disabled", true);
                    }else{
                        $(this).prop("disabled", false);
                    }
                });

                $(select).val('');

                select.select2({
                    language: $("html").attr("lang"),
                    allowClear: true,
                    cache: true,
                    placeholder: select.data('placeholder')
                });
            });
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/statistics/partials/global_filters/groupByConsultantLevel.vue